// src/components/PageNotFound.js
import React from 'react';
import { Container, Typography } from '@mui/material';
 
const PageNotFound = () => {
    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Typography variant="h1">404 Error</Typography>
            <Typography variant="h3">Page Not Found</Typography>
        </Container>
    );
};
export default PageNotFound;